import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=d9a20554"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports